/*
    - Does every Behaviour have a parent? YES, except roots
    - Does every Behaviour connect to the application in some way? YES, via its parents.
    - Ressources used by the behaviour must be available via its constructor OR via its parent
    - Is the parent set on construction or on start()? Construction
 */
import { ewent, observe } from "../reactive";
import { LifetimeManager } from "../lifetime/LifetimeManager";
export default class Behaviour {
    constructor() {
        this.lifetime_manager = new LifetimeManager();
        this._subBehaviours = [];
        this.started = ewent();
        this.stopped = ewent();
        this._started = false;
        this._starting = false;
    }
    withSub(sub) {
        this._subBehaviours.push(sub);
        if (this._started)
            sub.start();
        return sub;
    }
    start() {
        if (this._started)
            return this;
        this._started = true;
        this._starting = true;
        this.begin();
        this._starting = false;
        if (this._started)
            this.started.trigger(null);
        this._subBehaviours.forEach(c => c.start());
        return this;
    }
    stop() {
        this._subBehaviours.forEach(c => c.stop());
        this.lifetime_manager.kill();
        if (this._started) {
            this._started = false;
            this.end();
            if (!this._starting)
                this.stopped.trigger(null);
        }
    }
    isActive() {
        return this._started;
    }
    onStop(f) {
        this.stopped.on(f);
        return this;
    }
    endLifetime() {
        this.stop();
    }
}
export class SingleBehaviour extends Behaviour {
    constructor() {
        super(...arguments);
        this.behaviour = observe(null);
        this.content_stopped = ewent();
    }
    begin() {
        if (this.behaviour.value())
            this.behaviour.value().start();
    }
    end() {
        if (this.behaviour.value())
            this.behaviour.value().stop();
    }
    get() {
        return this.behaviour.value();
    }
    set(behaviour) {
        if (this.behaviour.value()) {
            if (this.behaviour.value().isActive())
                this.behaviour.value().stop();
            this.behaviour.set(null);
        }
        if (behaviour) {
            this.behaviour.set(behaviour);
            behaviour.stopped.on(() => {
                if (this.behaviour.value() == behaviour)
                    this.content_stopped.trigger(behaviour);
            });
            if (this.isActive())
                behaviour.start();
        }
        return this;
    }
}
